import { ThemeProvider } from "@material-ui/styles";
import { Redirect, Route, Switch } from "react-router-dom";
import {
  REACT_ACCESSLEVELS_LIST,
  REACT_ADD_DEVICE_TO_ACCESSLEVEL,
  REACT_ADD_EDIT_DAY_LIGHT_TIME,
  REACT_ADD_PRODUCT,
  REACT_ADD_TIMESLOTS,
  REACT_ADMIN_TRANSACTIONS,
  REACT_ATLAS_INTEGRATION,
  REACT_CREATE_CUSTOMER,
  REACT_CREATE_DEALER,
  REACT_CREATE_DEVICE_TYPE,
  REACT_CREATE_DISCOUNT,
  REACT_CREATE_EMAIL_REPORT,
  REACT_CREATE_KEY_CONFIGURATION,
  REACT_CREATE_SUBSCRIPTION,
  REACT_CREATE_USER,
  REACT_CUSTOMER_REPORT,
  REACT_CUSTOMER_REPORT_VIEW,
  REACT_CUSTOMER_TRANSACTION_VIEW,
  REACT_CUSTOMER_TRANSACTION_VIEW_PAGE,
  REACT_CUSTOMER_VIEW_REPORT,
  REACT_CUSTOMERS_LIST,
  REACT_DASHBOARD_PANEL,
  REACT_DATEFORMAT_ADMIN_DEALER,
  REACT_DAY_LIGHT_TIME,
  REACT_DEALER,
  REACT_DEALER_CUSTOMER_REPORT,
  REACT_DEALER_PRODUCT_LIST,
  REACT_DEALER_REPORT,
  REACT_DEALER_TRANSACTION,
  REACT_DELIVERY_REPORT,
  REACT_DEVICE_ADD_INSTRUCTION,
  REACT_DEVICE_COMMANDS,
  REACT_DEVICE_INFO,
  REACT_DEVICE_LIST,
  REACT_DEVICE_TYPE,
  REACT_EDIT_SUBSCRIPTION,
  REACT_EMAIL_REPORT,
  REACT_INTEGRATION,
  REACT_INTEGRATION_ACCESS_LEVEL_LIST,
  REACT_INTEGRATION_CARD_HOLDER_LIST,
  REACT_INTEGRATION_LIST,
  REACT_KEY_CONFIGURATION,
  REACT_LOGIN_AUTHENTICATE,
  REACT_MANAGE_ACCESSLEVELS,
  REACT_NDA_EDIT,
  REACT_OPERATION_LOGS,
  REACT_PLAN_PURCHASED,
  REACT_PRE_REGISTRATION_LIST,
  REACT_PRE_REGISTRATION_REPORT_LIST,
  REACT_PRODUCT_CREATE_WAREHOUSE,
  REACT_PRODUCT_MANAGEMENT,
  REACT_SAFETY_INSTRUCTIONS,
  REACT_SAFETY_VIDEO_ACKNOWLEDGEMENT,
  REACT_SAFETY_VIDEO_ACKNOWLEDGEMENT_SELF_REGISTRATION,
  REACT_SELF_REGISTRATION_LIST,
  REACT_SMS_EDIT,
  REACT_SMS_TEMPLATE,
  REACT_SUBSCRIPTION_CARDS,
  REACT_SUBSCRIPTION_MANAGEMENT,
  REACT_TEST_EXPIRED_DATA,
  REACT_TIME_SLOTS,
  REACT_TRANSACTION_DETAILS,
  REACT_UNAUTHORIZED,
  REACT_UPDATE_TIMESLOT,
  REACT_URL_ADD_CARD_TEMPLATE,
  REACT_URL_ADDCHECKOUT,
  REACT_URL_ADDDEVICES,
  REACT_URL_ADDITIONAL_SETTINGS,
  REACT_URL_ADDRESSTYPE,
  REACT_URL_APPROVAL,
  REACT_URL_BLACKLISTTYPE,
  REACT_URL_BLACKLISTVISITORS,
  REACT_URL_CARDTEMPLATE,
  REACT_URL_CHECKINOUTDEVICES,
  REACT_URL_CHECKLIST,
  REACT_URL_CHECKLIST_ITEM,
  REACT_URL_CHECKLISTTEMPLATE_USA,
  REACT_URL_COMPANYRPROFILE,
  REACT_URL_CREATE_LEVEL,
  REACT_URL_CUSTOMER_TRANSACTION_DETAILS,
  REACT_URL_DAILYREPORT,
  REACT_URL_DASHBOARD,
  REACT_URL_DEALER_DETAILS,
  REACT_URL_DEVICELIST,
  REACT_URL_DISCOUNTS,
  REACT_URL_EMERGENCYMESSAGE,
  REACT_URL_EMPLOYEE,
  REACT_URL_FLOWCHART,
  REACT_URL_HEALTHQUESTIONARIES,
  REACT_URL_INVITATIONREPORT,
  REACT_URL_LEVEL,
  REACT_URL_MONTHLY_INCOME,
  REACT_URL_NDA,
  REACT_URL_OFFENCE,
  REACT_URL_PAYMENT_METHOD,
  REACT_URL_PURPOSETYPE,
  REACT_URL_PURPOSETYPE_USA,
  REACT_URL_REPORTINVITATION,
  REACT_URL_REPORTREGISTRATION,
  REACT_URL_RESTRICTTYPE,
  REACT_URL_SELFREGISTRATIONREPORT,
  REACT_URL_SITE,
  REACT_URL_SITETYPE,
  REACT_URL_USER_LIST,
  REACT_URL_USERPROFILE,
  REACT_URL_USERROLE,
  REACT_URL_USERS,
  REACT_URL_VISITINVITE,
  REACT_URL_VISITORACCESSLEVEL,
  REACT_URL_VISITORLOGS,
  REACT_URL_VISITORTYPE,
  REACT_URL_WALKINREGISTRATION,
  REACT_URL_WALKINREGISTRATIONREPORT,
  REACT_URL_WALKINVISIT,
  REACT_URL_WATCHLIST,
  REACT_URL_WATCHLISTGLOBAL,
  REACT_URL_ZONE,
  REACT_VIEW_CUSTOMERS_DETAILS,
  REACT_VIEW_DEALER_DETAILS,
  REACT_VIEW_DEVICE,
  REACT_VIEW_KEY_CONFIGURATION,
  REACT_VISITOR_ACCESS_LEVEL_LIST,
  REACT_VISITOR_QR_PAGE,
} from "./actions/EndPoints";
import { LeftSidebar } from "./layout-blueprints";
import MuiTheme from "./theme";

import { useEffect } from "react";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min.js";
import Loader from "./components/Loader/Loader";
import SecuredRoute from "./config/SecuredRoute";
import AdditionalSettings from "./Pages/AdditionalSettings/AdditionalSettings";
import Approvals from "./Pages/Approvals/Approvals";
import AtlasIntegration from "./Pages/AtlasIntegration/AtlasIntegration.js";
import BlacklistType from "./Pages/BlacklistType/BlacklistType";
import BlacklistVisitors from "./Pages/BlacklistVisitors/BlacklistVisitors";
import AddCardTemplate from "./Pages/CardTemplate/AddCardTemplate";
import CardTemplate from "./Pages/CardTemplate/CardTemplate";
import ChecklistItems from "./Pages/Checklist/ChecklistItems";
import ChecklistTemplate from "./Pages/Checklist/ChecklistTemplate";
import ChecklistTemplateUSA from "./Pages/ChecklistTemplateUSA/ChecklistTemplateUSA";
import CreateCustomer from "./Pages/Customer/CreateCustomer.js";
import CustomerReports from "./Pages/Customer/CustomerReports.js";
import CustomerReportViewDetails from "./Pages/Customer/CustomerReportViewDetails.js";
import CustomersList from "./Pages/Customer/CustomersList.js";
import CustomersReportByDealerId from "./Pages/Customer/CustomersReportByDealerId.js";
import CustomersReportView from "./Pages/Customer/CustomersReportView.js";
import CustomerTransactionView from "./Pages/Customer/CustomerTransactionView.js";
import TransactionReportForCustomer from "./Pages/Customer/TransactionReportForCustomer.js";
import TransactionReportViewPage from "./Pages/Customer/TransactionReportViewPage.js";
import ViewCustomer from "./Pages/Customer/ViewCustomer.js";
import DailyReports from "./Pages/DailyReports/DailyReports";
import InvitationReport from "./Pages/DailyReports/InvitationReport";
import PreRegistrationReports from "./Pages/DailyReports/PreRegistrationReports.js";
import SelfRegisterReport from "./Pages/DailyReports/SelfRegisterReport";
import WalkInRegistrationReport from "./Pages/DailyReports/WalkInRegistrationReport";
import Dashboard from "./Pages/DashBoard/dashboard.js";
import DashboardPanel from "./Pages/DashboardPanel/DashboardPanel.js";
import CreateDayLightTime from "./Pages/DayLightTime/CreateDayLightTime.js";
import DayLightTime from "./Pages/DayLightTime/DayLightTime.js";
import AdminTransactions from "./Pages/Dealer/AdminTransactions.js";
import CreateDealer from "./Pages/Dealer/CreateDealer";
import CreateLevel from "./Pages/Dealer/CreateLevel";
import CreateSubscription from "./Pages/Dealer/CreateSubscription.js";
import CustomerTransactionDetails from "./Pages/Dealer/CustomerTransactionDetails";
import Dealer from "./Pages/Dealer/Dealer";
import DealerDetails from "./Pages/Dealer/DealerDetails";
import DealerProducts from "./Pages/Dealer/DealerProducts.js";
import DealersReport from "./Pages/Dealer/DealersReport.js";
import DealerTransaction from "./Pages/Dealer/DealerTransaction.js";
import EditSubscription from "./Pages/Dealer/EditSubscription.js";
import Level from "./Pages/Dealer/Level";
import MonthlyIncome from "./Pages/Dealer/MonthlyIncome";
import PlanPurchased from "./Pages/Dealer/PlanPurchased.js";
import SubscriptionCards from "./Pages/Dealer/SubscriptionCards";
import SubscriptionManagement from "./Pages/Dealer/SubscriptionManagement.js";
import ViewDealerDetails from "./Pages/Dealer/ViewDealerDetails";
import DeliveryReport from "./Pages/DeliveryReport/DeliveryReport";
import DeviceCommands from "./Pages/DeviceCommandAndOpeartionLogs/DeviceCommands.js";
import OperationLogs from "./Pages/DeviceCommandAndOpeartionLogs/OpeartionLogs.js";
import Device from "./Pages/DeviceManagementV2/Device";
import { ViewDevice } from "./Pages/DeviceManagementV2/ViewDevice";
import ZlinkAddDeviceInfo from "./Pages/DeviceManagementV2/ZlinkAddDeviceInfo";
import CreateDiscount from "./Pages/Discount/CreateDiscount.js";
import Discount from "./Pages/Discount/Discount.js";
import DymoPrint from "./Pages/DymoPrint/DymoPrint";
import EmailReportCreate from "./Pages/EmailReport/EmailReportCreate.js";
import EmergencyMessage from "./Pages/EmergencyMessage/EmergencyMessage.js";
import Employee from "./Pages/Employee/Employee";
import VisitorsExpiredEvents from "./Pages/EventListeners/VisitorsExpiredEvents.js";
import AccessLevelRuleLists from "./Pages/Genetec/AccessLevelRuleLists.js";
import CardHolderGroupLists from "./Pages/Genetec/CardHolderGroupLists.js";
import IntegrationAssigmentToEmployee from "./Pages/Genetec/IntegrationAssigmentToEmployee.js";
import HealthQuestionaries from "./Pages/HealthQuestionaries/HealthQuestionaries";
import Integration from "./Pages/Integrations/Integration.js";
import ChecklistForm from "./Pages/Invitations/ChecklistForm";
import ConfirmVisitV2 from "./Pages/Invitations/ConfirmVisitV2";
import InvitationsList from "./Pages/Invitations/InvitationsList";
import RejectVisiForConfirm from "./Pages/Invitations/RejectVisiForConfirm.js";
import RejectVisit from "./Pages/Invitations/RejectVisit";
import RejectVisitByAdmin from "./Pages/Invitations/RejectVisitByAdmin.js";
import RejectVisitor from "./Pages/Invitations/RejectVisitor.js";
import ReportInvitation from "./Pages/Invitations/ReportInvitation";
import ReportSelfRegistration from "./Pages/Invitations/ReportSelfRegistration";
import ReportWalkinRegistartion from "./Pages/Invitations/ReportWalkinRegistartion";
import ResultPage from "./Pages/Invitations/ResultPage";
import VisitSuccess from "./Pages/Invitations/VisitSuccess";
import CreateKeyConfiguration from "./Pages/KeyConfiguration/CreateKeyConfiguration.js";
import KeyConfiguration from "./Pages/KeyConfiguration/KeyConfiguration.js";
import KeyConfigView from "./Pages/KeyConfiguration/KeyConfigView.js";
import LoginAuthentication from "./Pages/LoginAuthentication/LoginAuthentication.js";
import VisitorLogs from "./Pages/Logs/VisitorLogs";
import EditNDA from "./Pages/NDA/EditNDA.js";
import NDA from "./Pages/NDA/NDA.js";
import NDADocument from "./Pages/NDA/NDADocument.js";
import NDADocumentData from "./Pages/NDA/NDADocumentData.js";
import SelfRegistrationNDADocumentData from "./Pages/NDA/SelfRegistrationNDADocumentData.js";
import SelfRegistrationNDAForm from "./Pages/NDA/SelfRegistrationNDAForm.js";
import Offence from "./Pages/Offence/Offence";
import ChangePassword from "./Pages/OnBoardV2/ChangePassword";
import CreateCompany from "./Pages/OnBoardV2/CreateCompany";
import CustomCarousel from "./Pages/OnBoardV2/CustomCarousel";
import EmailSentScreen from "./Pages/OnBoardV2/EmailSentScreen";
import ForgotPasswordScreen from "./Pages/OnBoardV2/ForgotPasswordScreen";
import LinkExpired from "./Pages/OnBoardV2/LinkExpired";
import LoginFormForHost from "./Pages/OnBoardV2/LoginFormForHost.js";
import LoginFormV2 from "./Pages/OnBoardV2/LoginFormV2";
import PasswordSuccess from "./Pages/OnBoardV2/PasswordSuccess";
import PrivacyPolicyScreen from "./Pages/OnBoardV2/PrivacyPolicyScreen";
import SelectCompany from "./Pages/OnBoardV2/SelectCompany";
import SignUpScreenV2 from "./Pages/OnBoardV2/SignUpScreenV2";
import SuccessScreen from "./Pages/OnBoardV2/SuccessScreen";
import ThankYouScreen from "./Pages/OnBoardV2/ThankYouScreen";
import UserAgreement from "./Pages/OnBoardV2/UserAgreement";
import Zlink from "./Pages/OnBoardV2/Zlink";
import PaymentMethod from "./Pages/PaymentMethod/PaymentMethod.js";
import PreRegistrationLists from "./Pages/PerRegistration/PreRegistrationLists.js";
import ActivateAccount from "./Pages/Person/ActivateAccount";
import AddProduct from "./Pages/ProductManagement/AddProduct.js";
import AddProductFormat from "./Pages/ProductManagement/AddProductFormat.js";
import Products from "./Pages/ProductManagement/Products.js";
import CompanyProfile from "./Pages/ProfilePages/CompanyProfile";
import UserProfile from "./Pages/ProfilePages/UserProfile";
import PurposeType from "./Pages/PurposeType/PurposeType";
import VisitorAccessLevelsPage from "./Pages/PurposeType/VisitorAccessLevelsPage";
import VisitorAddAccessLevelDialog from "./Pages/PurposeType/VisitorAddAccessLevelDialog";
import PurposeTypeUSA from "./Pages/PurposeTypeUSA/PurposeTypeUSA";
import QRcode from "./Pages/QRCode/QRcode";
import RegistrationList from "./Pages/Registrations/RegistrationList";
import RestrictType from "./Pages/RestrictType/RestrictType";
import SelfCancel from "./Pages/SelfRegistration/SelfCancel";
import SelfRegistration from "./Pages/SelfRegistration/SelfRegistration";
import SelfRegistrationCheckList from "./Pages/SelfRegistration/SelfRegistrationCheckList.js";
import SelfRegistrationList from "./Pages/SelfRegistration/SelfRegistrationList.js";
import SelfRegistrationSuccess from "./Pages/SelfRegistration/SelfRegistrationSuccess";
import SelfReject from "./Pages/SelfRegistration/SelfReject";
import DateFormatForHqAndDealer from "./Pages/SettingForHq&Dealer/DateFormatForHqAndDealer.js";
import AddressType from "./Pages/SiteManagement/AddressType/AddressType";
import AddCheckInOutDevices from "./Pages/SiteManagement/CheckInCheckOutDevices/AddCheckInOutDevices";
import AddCheckOutDevice from "./Pages/SiteManagement/CheckInCheckOutDevices/AddCheckOutDevice";
import AddCheckOutDeviceInfo from "./Pages/SiteManagement/CheckInCheckOutDevices/AddCheckOutDeviceInfo";
import AddDeviceInfo from "./Pages/SiteManagement/CheckInCheckOutDevices/AddDeviceInfo";
import CheckInCheckOutDevices from "./Pages/SiteManagement/CheckInCheckOutDevices/CheckInCheckOutDevices";
import Site from "./Pages/SiteManagement/Site/Site";
import SiteType from "./Pages/SiteManagement/SiteType/SiteType";
import EditSmsTemplate from "./Pages/SmsTemplate/EditSmsTemplate";
import SmsTemplate from "./Pages/SmsTemplate/SmsTemplate";
import AddTimeSlots from "./Pages/TimeSlots/AddTimeSlots";
import { TimeSlotList } from "./Pages/TimeSlots/TimeSlotList";
import updateTime from "./Pages/TimeSlots/UpdateTimeSlot";
import UnAuthorizedAccess from "./Pages/UnAuthorizedAccess/UnAuthorizedAccess.js";
import CreateDeviceType from "./Pages/UploadAPKFile/CreateDeviceType.js";
import DeviceTypeLists from "./Pages/UploadAPKFile/DeviceTypeLists.js";
import CreateUser from "./Pages/User/CreateUser.js";
import User from "./Pages/User/User.js";
import UserList from "./Pages/UserRole/UserList";
import UserRole from "./Pages/UserRole/UserRole";
import SafetyVideo from "./Pages/VideoUpload/SafetyVideo.js";
import SafetyVideoAcknowledgement from "./Pages/VideoUpload/SafetyVideoAcknowledgement.js";
import SafetyVideoAcknowledgementForSelfRegistration from "./Pages/VideoUpload/SafetyVideoAcknowledgementForSelfRegistration.js";
import AccessAddDevice from "./Pages/VisitingAccessLevels/AddDeviceToAccessLevel";
import ManageAccessLevels from "./Pages/VisitingAccessLevels/ManageAccessLevel";
import VisitingAccessLevels from "./Pages/VisitingAccessLevels/VisitingAccessLevels";
import VisitingFlowchart from "./Pages/VisitingFlowchart/VisitingFlowchart";
import VisitorType from "./Pages/VisitorType/VisitorType";
import WatchlistTemplate from "./Pages/Watchlist/WatchlistTemplate";
import WatchlistTemplateList from "./Pages/Watchlist/WatchlistTemplateList";
import ZoneList from "./Pages/ZoneManagment/ZoneList";

const Routes = () => {
  const location = useLocation();

  useEffect(() => {
    window.removeEventListener("beforeunload", function() {
      window.onbeforeunload = null;
    });
  }, [location]);

  return (
    <ThemeProvider theme={MuiTheme}>
      <Loader />
      <Switch>
        <Redirect exact from="/" to="/vis/login" />
        <Route path="/vis/login" component={LoginFormV2} />
        <Route path="/vis/verify-company" component={SelectCompany} />
        <Route path="/vis/carousel" component={CustomCarousel} />
        <Route path="/vis/signup" component={SignUpScreenV2} />
        <Route path="/vis/email-sent" component={EmailSentScreen} />
        <Route path="/vis/link-expired" component={LinkExpired} />
        <Route path="/vis/forgot-password" component={ForgotPasswordScreen} />
        <Route path="/vis/success-screen" component={SuccessScreen} />
        <Route path="/vis/reset-password" component={ChangePassword} />
        <Route path="/vis/user-created" component={ThankYouScreen} />
        <Route path="/vis/password-success" component={PasswordSuccess} />
        <Route path="/vis/create-company" component={CreateCompany} />
        <Route path="/vis/privacy-policy" component={PrivacyPolicyScreen} />
        <Route path="/vis/user-agreement" component={UserAgreement} />
        <Route path="/vis/confirm-page" component={ConfirmVisitV2} />
        <Route
          path={REACT_SAFETY_VIDEO_ACKNOWLEDGEMENT}
          component={SafetyVideoAcknowledgement}
        />
        <Route
          path={REACT_SAFETY_VIDEO_ACKNOWLEDGEMENT_SELF_REGISTRATION}
          component={SafetyVideoAcknowledgementForSelfRegistration}
        />
        <Route path="/vis/VerifyNDA" component={NDADocument} />
        <Route path="/vis/secondndadocument" component={NDADocumentData} />
        <Route
          path="/vis/selfRegistration/NDA"
          component={SelfRegistrationNDAForm}
        />
        <Route
          path="/vis/selfRegistrationNDADocument"
          component={SelfRegistrationNDADocumentData}
        />
        <Route
          path="/vis/selfRegistration-confirm-page"
          component={SelfRegistrationSuccess}
        />
        <Route
          path="/vis/selfRegistration-checklist"
          component={SelfRegistrationCheckList}
        />
        <Route path="/vis/check-list-form" component={ChecklistForm} />
        <Route path="/vis/visit-success" component={VisitSuccess} />
        <Route path="/vis/reject" exact component={RejectVisit} />
        <Route
          path="/vis/reject/visit"
          exact
          component={RejectVisiForConfirm}
        />
        <Route path="/vis/cancel/Visit" component={RejectVisitor} />
        <Route path="/vis/result-page" component={ResultPage} />
        <Route path="/vis/activate-account" component={ActivateAccount} />
        <Route path="/vis/zlink" component={Zlink} />
        <Route path="/vis/selfRegistartion" component={SelfRegistration} />
        <Route path="/vis/confirms-page/rejects" exact component={SelfReject} />
        <Route path="/vis/cancel-page/cancel" component={SelfCancel} />
        <Route path="/vis/rejectByAdmin" component={RejectVisitByAdmin} />
        <Route path="/vis/LoginPageForHost" component={LoginFormForHost} />
        <Route path={REACT_VISITOR_QR_PAGE} component={QRcode} />
        <Route
          path={REACT_LOGIN_AUTHENTICATE}
          component={LoginAuthentication}
        />
        <Route path={REACT_UNAUTHORIZED} component={UnAuthorizedAccess} />
        <LeftSidebar>
          <SecuredRoute
            path={REACT_URL_DASHBOARD}
            component={Dashboard}
            allowedRoles={["Owner", "Admin", "Front Desk", "Employee"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_DASHBOARD_PANEL}
            component={DashboardPanel}
            allowedRoles={["Owner", "Admin", "Front Desk", "Employee"]}
            allowedCompanyType={["PARTNER", "NONE"]}
          />
          <SecuredRoute
            path={REACT_URL_VISITINVITE}
            component={InvitationsList}
            allowedRoles={["Owner", "Admin", "Front Desk", "Employee"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_WALKINVISIT}
            component={RegistrationList}
            allowedRoles={["Owner", "Admin", "Front Desk"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_APPROVAL}
            component={Approvals}
            allowedRoles={["Owner", "Admin", "Front Desk", "Employee"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_VISITORLOGS}
            component={VisitorLogs}
            allowedRoles={["Owner", "Admin", "Front Desk", "Employee"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_USERPROFILE}
            component={UserProfile}
            allowedRoles={["Owner", "Admin", "Front Desk", "Employee"]}
            allowedCompanyType={["CUSTOMER", "PARTNER", "NONE"]}
          />
          <SecuredRoute
            path={REACT_URL_COMPANYRPROFILE}
            component={CompanyProfile}
            allowedRoles={["Owner", "Admin", "Front Desk", "Employee"]}
            allowedCompanyType={["CUSTOMER", "PARTNER", "NONE"]}
          />
          <SecuredRoute
            path={REACT_URL_SITE}
            component={Site}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_DAY_LIGHT_TIME}
            component={DayLightTime}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />

          <SecuredRoute
            path={REACT_ADD_EDIT_DAY_LIGHT_TIME}
            component={CreateDayLightTime}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_SITETYPE}
            component={SiteType}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_ADDRESSTYPE}
            component={AddressType}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_CHECKINOUTDEVICES}
            component={CheckInCheckOutDevices}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_PURPOSETYPE}
            component={PurposeType}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_RESTRICTTYPE}
            component={RestrictType}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_WATCHLIST}
            component={WatchlistTemplate}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_WATCHLISTGLOBAL}
            component={WatchlistTemplateList}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_CHECKLIST}
            component={ChecklistTemplate}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_VISITORACCESSLEVEL}
            component={VisitorAccessLevelsPage}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_CHECKLIST_ITEM}
            component={ChecklistItems}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_DEVICELIST}
            component={Device}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_ADDDEVICES}
            component={AddCheckInOutDevices}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_ADDCHECKOUT}
            component={AddCheckOutDevice}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_EMERGENCYMESSAGE}
            component={EmergencyMessage}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_FLOWCHART}
            component={VisitingFlowchart}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_DEVICE_LIST}
            component={AddDeviceInfo}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_DEVICE_INFO}
            component={AddCheckOutDeviceInfo}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_DEVICE_ADD_INSTRUCTION}
            component={ZlinkAddDeviceInfo}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_ACCESSLEVELS_LIST}
            component={VisitingAccessLevels}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_TIME_SLOTS}
            component={TimeSlotList}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_VIEW_DEVICE}
            component={ViewDevice}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_MANAGE_ACCESSLEVELS}
            component={ManageAccessLevels}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_ADD_TIMESLOTS}
            component={AddTimeSlots}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_ADD_DEVICE_TO_ACCESSLEVEL}
            component={AccessAddDevice}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_UPDATE_TIMESLOT}
            component={updateTime}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_ZONE}
            component={ZoneList}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_WALKINREGISTRATION}
            component={ReportWalkinRegistartion}
            allowedRoles={["Owner", "Admin", "Front Desk"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_REPORTINVITATION}
            component={ReportInvitation}
            allowedRoles={["Owner", "Admin", "Front Desk"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_REPORTREGISTRATION}
            component={ReportSelfRegistration}
            allowedRoles={["Owner", "Admin", "Front Desk"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_CARDTEMPLATE}
            component={CardTemplate}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_ADD_CARD_TEMPLATE}
            component={AddCardTemplate}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_ADDITIONAL_SETTINGS}
            component={AdditionalSettings}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_TEST_EXPIRED_DATA}
            component={VisitorsExpiredEvents}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_NDA}
            component={NDA}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_SAFETY_INSTRUCTIONS}
            component={SafetyVideo}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_VISITORTYPE}
            component={VisitorType}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_HEALTHQUESTIONARIES}
            component={HealthQuestionaries}
            llowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_CHECKLISTTEMPLATE_USA}
            component={ChecklistTemplateUSA}
            llowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_VISITOR_ACCESS_LEVEL_LIST}
            component={VisitorAddAccessLevelDialog}
            llowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_BLACKLISTTYPE}
            component={BlacklistType}
            llowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_USERROLE}
            component={UserRole}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_PURPOSETYPE_USA}
            component={PurposeTypeUSA}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_EMPLOYEE}
            component={Employee}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_INVITATIONREPORT}
            component={InvitationReport}
            allowedRoles={["Owner", "Admin", "Front Desk"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_WALKINREGISTRATIONREPORT}
            component={WalkInRegistrationReport}
            allowedRoles={["Owner", "Admin", "Front Desk"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_SELFREGISTRATIONREPORT}
            component={SelfRegisterReport}
            allowedRoles={["Owner", "Admin", "Front Desk"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_DAILYREPORT}
            component={DailyReports}
            allowedRoles={["Owner", "Admin", "Front Desk"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_BLACKLISTVISITORS}
            component={BlacklistVisitors}
            allowedRoles={["Owner", "Admin", "Front Desk", "Employee"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_DEALER}
            component={Dealer}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["NONE"]}
          />
          <SecuredRoute
            path={REACT_CREATE_DEALER}
            component={CreateDealer}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["NONE"]}
          />
          <SecuredRoute
            path={REACT_SUBSCRIPTION_MANAGEMENT}
            component={SubscriptionManagement}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["NONE", "PARTNER"]}
          />
          <SecuredRoute
            path={REACT_PRODUCT_MANAGEMENT}
            component={Products}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["NONE"]}
          />
          <SecuredRoute
            path={REACT_ADD_PRODUCT}
            component={AddProduct}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["NONE"]}
          />
          <SecuredRoute
            path={REACT_CREATE_SUBSCRIPTION}
            component={CreateSubscription}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["NONE"]}
          />
          <SecuredRoute
            path={REACT_EDIT_SUBSCRIPTION}
            component={EditSubscription}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["NONE"]}
          />
          <SecuredRoute path={REACT_URL_USER_LIST} component={UserList} />
          <SecuredRoute path={REACT_URL_OFFENCE} component={Offence} />
          <SecuredRoute
            path={REACT_URL_DEALER_DETAILS}
            component={DealerDetails}
          />
          <SecuredRoute
            path={REACT_URL_CUSTOMER_TRANSACTION_DETAILS}
            component={CustomerTransactionDetails}
          />
          <SecuredRoute
            path={REACT_URL_MONTHLY_INCOME}
            component={MonthlyIncome}
          />
          <SecuredRoute path={REACT_URL_CREATE_LEVEL} component={CreateLevel} />
          <SecuredRoute path={REACT_URL_LEVEL} component={Level} />
          <SecuredRoute
            path={REACT_SUBSCRIPTION_CARDS}
            component={SubscriptionCards}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER", "PARTNER"]}
          />
          <SecuredRoute
            path={REACT_DELIVERY_REPORT}
            component={DeliveryReport}
            allowedRoles={["Owner", "Admin", "Front Desk"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute path={"/vis/print"} component={DymoPrint} />
          <SecuredRoute
            path={REACT_SMS_TEMPLATE}
            component={SmsTemplate}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_SMS_EDIT}
            component={EditSmsTemplate}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_NDA_EDIT}
            component={EditNDA}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_ATLAS_INTEGRATION}
            component={AtlasIntegration}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_CREATE_CUSTOMER}
            component={CreateCustomer}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["PARTNER"]}
          />
          <SecuredRoute
            path={REACT_CUSTOMERS_LIST}
            component={CustomersList}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["PARTNER"]}
          />
          <SecuredRoute
            path={REACT_VIEW_CUSTOMERS_DETAILS}
            component={ViewCustomer}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["PARTNER"]}
          />
          <SecuredRoute
            path={REACT_VIEW_DEALER_DETAILS}
            component={ViewDealerDetails}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["NONE"]}
          />
          <SecuredRoute
            path={REACT_DEALER_REPORT}
            component={DealersReport}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["NONE"]}
          />
          <SecuredRoute
            path={REACT_DEALER_CUSTOMER_REPORT}
            component={CustomersReportByDealerId}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["NONE"]}
          />
          <SecuredRoute
            path={REACT_ADMIN_TRANSACTIONS}
            component={AdminTransactions}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["NONE"]}
          />
          <SecuredRoute
            path={REACT_DEALER_TRANSACTION}
            component={DealerTransaction}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["PARTNER"]}
          />
          <SecuredRoute
            path={REACT_CUSTOMER_REPORT}
            component={CustomerReports}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["PARTNER"]}
          />
          <SecuredRoute
            path={REACT_CUSTOMER_VIEW_REPORT}
            component={CustomerReportViewDetails}
          />
          <SecuredRoute
            path={REACT_TRANSACTION_DETAILS}
            component={TransactionReportForCustomer}
          />
          <SecuredRoute
            path={REACT_CUSTOMER_TRANSACTION_VIEW_PAGE}
            component={TransactionReportViewPage}
          />
          <SecuredRoute
            path={REACT_CUSTOMER_TRANSACTION_VIEW}
            component={CustomerTransactionView}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["NONE"]}
          />
          <SecuredRoute
            path={REACT_CUSTOMER_REPORT_VIEW}
            component={CustomersReportView}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["NONE", "PARTNER"]}
          />
          <SecuredRoute
            path={REACT_SELF_REGISTRATION_LIST}
            component={SelfRegistrationList}
            allowedRoles={["Owner", "Admin", "Front Desk", "Employee"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_URL_USERS}
            component={User}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["NONE", "PARTNER"]}
          />
          <SecuredRoute
            path={REACT_CREATE_USER}
            component={CreateUser}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["NONE", "PARTNER"]}
          />
          <SecuredRoute
            path={REACT_URL_DISCOUNTS}
            component={Discount}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["NONE"]}
          />
          <SecuredRoute
            path={REACT_URL_PAYMENT_METHOD}
            component={PaymentMethod}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["PARTNER"]}
          />
          <SecuredRoute
            path={REACT_CREATE_DISCOUNT}
            component={CreateDiscount}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["NONE"]}
          />
          <SecuredRoute
            path={REACT_DATEFORMAT_ADMIN_DEALER}
            component={DateFormatForHqAndDealer}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["NONE", "PARTNER"]}
          />
          <SecuredRoute
            path={REACT_KEY_CONFIGURATION}
            component={KeyConfiguration}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["NONE"]}
          />
          <SecuredRoute
            path={REACT_CREATE_KEY_CONFIGURATION}
            component={CreateKeyConfiguration}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["NONE"]}
          />
          <SecuredRoute
            path={REACT_VIEW_KEY_CONFIGURATION}
            component={KeyConfigView}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["NONE"]}
          />
          {/* <SecuredRoute path={REACT_EMAIL_REPORT} component={ProductTabs} /> */}

          <SecuredRoute
            path={REACT_EMAIL_REPORT}
            component={EmailReportCreate}
          />
          <SecuredRoute
            path={REACT_PLAN_PURCHASED}
            component={PlanPurchased}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["PARTNER"]}
          />
          <SecuredRoute
            path={REACT_DEVICE_TYPE}
            component={DeviceTypeLists}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["NONE"]}
          />
          <SecuredRoute
            path={REACT_CREATE_DEVICE_TYPE}
            component={CreateDeviceType}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["NONE"]}
          />
          <SecuredRoute
            path={REACT_INTEGRATION}
            component={Integration}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_DEALER_PRODUCT_LIST}
            component={DealerProducts}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["NONE", "PARTNER"]}
          />
          <SecuredRoute
            path={REACT_PRODUCT_CREATE_WAREHOUSE}
            component={AddProductFormat}
            allowedRoles={["Owner"]}
          />
          <SecuredRoute
            path={REACT_CREATE_EMAIL_REPORT}
            component={EmailReportCreate}
          />
          <SecuredRoute
            path={REACT_OPERATION_LOGS}
            component={OperationLogs}
            allowedRoles={["Owner", "Admin", "Front Desk", "Employee"]}
            allowedCompanyType={["CUSTOMER", "NONE", "PARTNER"]}
          />
          <SecuredRoute
            path={REACT_DEVICE_COMMANDS}
            component={DeviceCommands}
            allowedRoles={["Owner", "Admin", "Front Desk"]}
            allowedCompanyType={["CUSTOMER", "NONE", "PARTNER"]}
          />
          <SecuredRoute
            path={REACT_INTEGRATION_ACCESS_LEVEL_LIST}
            component={AccessLevelRuleLists}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_INTEGRATION_CARD_HOLDER_LIST}
            component={CardHolderGroupLists}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_INTEGRATION_LIST}
            component={IntegrationAssigmentToEmployee}
            allowedRoles={["Owner", "Admin"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_PRE_REGISTRATION_LIST}
            component={PreRegistrationLists}
            allowedRoles={["Owner", "Admin", "Employee", "Front Desk"]}
            allowedCompanyType={["CUSTOMER"]}
          />
          <SecuredRoute
            path={REACT_PRE_REGISTRATION_REPORT_LIST}
            component={PreRegistrationReports}
            allowedRoles={["Owner", "Admin", "Front Desk"]}
            allowedCompanyType={["CUSTOMER"]}
          />
        </LeftSidebar>
      </Switch>
    </ThemeProvider>
  );
};

export default Routes;
